import { useSliderLayout } from '../hooks/useSliderLayout';

type PaginationDotProps = {
	isActive: boolean;
};

const PaginationDot = ({ isActive }: PaginationDotProps) => {
	const { blockClass } = useSliderLayout();

	const renderTokens = () => {
		if (isActive) {
			return `bg-emphasis grow dib br-100 pa2 mr2 ml2 bw0 pointer outline-0`;
		}

		return `bg-muted-3 grow dib br-100 pa2 mr2 ml2 bw0 pointer outline-0`;
	};

	return (
		<div
			className={`paginationDot paginationDot--${blockClass} vtex-slider-layout-0-x-paginationDot vtex-slider-layout-0-x-paginationDot--${blockClass} ${isActive && `paginationDot--isActive paginationDot--${blockClass}--isActive vtex-slider-layout-0-x-paginationDot--isActive vtex-slider-layout-0-x-paginationDot--${blockClass}--isActive`} ${renderTokens()}`}
			style={{
				height: '0.625rem',
				width: '0.625rem',
			}}
		/>
	);
};

export default PaginationDot;
